webpackJsonp([54],{

/***/ "7ydy":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("SHl2");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("rjj0").default
var update = add("a2dcdad2", content, true, {});

/***/ }),

/***/ "SHl2":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".user-password[data-v-d7dabbe6]{padding:70px 55px}.user-password .form-list label[data-v-d7dabbe6]{text-align:right}.user-password .form-list .difference[data-v-d7dabbe6]{color:#ef6752}.user-password .form-list .difference i[data-v-d7dabbe6]{width:10px;height:10px;background:url(" + __webpack_require__("vng7") + ") no-repeat;background-size:contain}.user-password .form-list .difference[data-v-d7dabbe6]:after{content:\"\\4E24\\6B21\\5BC6\\7801\\8F93\\5165\\4E0D\\4E00\\81F4\"}", "", {"version":3,"sources":["/home/work/jenkins/workspace/FD-FE_hfsfd-student/src/views/index/components/UserPassword.vue"],"names":[],"mappings":"AAGA,gCACE,iBAAmB,CACpB,AACD,iDACI,gBAAkB,CACrB,AACD,uDACI,aAAe,CAClB,AACD,yDACM,WAAY,AACZ,YAAa,AACb,mDAAwE,AACxE,uBAAyB,CAC9B,AACD,6DACI,uDAAqB,CACxB","file":"UserPassword.vue","sourcesContent":["\n@charset \"UTF-8\";\n/*颜色库*/\n.user-password[data-v-d7dabbe6] {\n  padding: 70px 55px;\n}\n.user-password .form-list label[data-v-d7dabbe6] {\n    text-align: right;\n}\n.user-password .form-list .difference[data-v-d7dabbe6] {\n    color: #ef6752;\n}\n.user-password .form-list .difference i[data-v-d7dabbe6] {\n      width: 10px;\n      height: 10px;\n      background: url(../../../assets/images/common/wrong-icon.png) no-repeat;\n      background-size: contain;\n}\n.user-password .form-list .difference[data-v-d7dabbe6]::after {\n    content: '两次密码输入不一致';\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "SVdM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background-supplement-no-title-layout"},[_c('div',{staticClass:"layout-content user-content form"},[_c('form',{staticClass:"user-password"},[_c('div',{staticClass:"form-list password-validate"},[_c('label',[_vm._v("原密码:")]),_vm._v(" "),_c('el-input',{attrs:{"type":"password","placeholder":"请输入原密码","maxlength":20},on:{"blur":function($event){_vm.blurPassword('originalPassword','originalVerify')},"focus":function($event){_vm.focusInput('originalVerify')}},model:{value:(_vm.originalPassword),callback:function ($$v) {_vm.originalPassword=$$v},expression:"originalPassword"}}),_vm._v(" "),_c('div',{staticClass:"validate",class:_vm.originalVerify},[_c('i')])],1),_vm._v(" "),_c('div',{staticClass:"form-list password-validate"},[_c('label',[_vm._v("新密码:")]),_vm._v(" "),_c('el-input',{attrs:{"type":"password","placeholder":"请设置6位以上密码，支持英文、数字、符号","maxlength":20},on:{"blur":function($event){_vm.blurPassword('newPassword','newVerify')},"focus":function($event){_vm.focusInput('newVerify')}},model:{value:(_vm.newPassword),callback:function ($$v) {_vm.newPassword=$$v},expression:"newPassword"}}),_vm._v(" "),_c('div',{staticClass:"validate",class:_vm.newVerify},[_c('i')])],1),_vm._v(" "),_c('div',{staticClass:"form-list password-validate"},[_c('label',[_vm._v("确认新密码:")]),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"password"}}),_vm._v(" "),_c('el-input',{attrs:{"type":"password","placeholder":"请重复输入新密码","maxlength":20},on:{"blur":function($event){_vm.blurPassword('confirmPassword','confirmVerify')},"focus":function($event){_vm.focusInput('confirmVerify')}},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}}),_vm._v(" "),_c('div',{staticClass:"validate",class:_vm.confirmVerify},[_c('i')])],1),_vm._v(" "),_c('div',{staticClass:"form-list",staticStyle:{"margin-top":"10px","height":"20px","line-height":"20px"}},[_c('div',{staticClass:"warning-content",class:_vm.warnVerify},[_c('i'),_vm._v(_vm._s(_vm.warnMsg ? _vm.warnMsg : ''))])]),_vm._v(" "),_c('div',{staticClass:"form-list",staticStyle:{"margin-top":"0"}},[_c('el-button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"form-btn",on:{"click":_vm.handleModifyPwd}},[_vm._v("修改密码")])],1)])])])}
var staticRenderFns = []


/***/ }),

/***/ "VPQo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            flag: true, // 防止异步请求重复发送
            loading: false,
            originalPassword: '',
            originalVerify: '',
            newPassword: '',
            newVerify: '',
            confirmPassword: '',
            confirmVerify: '',
            warnVerify: null,
            warnMsg: ''
        };
    },

    methods: {
        blurPassword: function blurPassword(pwd, verify) {
            var password = this[pwd];
            if (password) {
                this.checkPassword(password, verify);
            }
        },
        focusInput: function focusInput(verify) {
            this[verify] = '';
            this.warnVerify = '';
            this.warnMsg = '';
        },
        checkPassword: function checkPassword(password, verify) {
            if (verify === 'originalVerify') {
                if (!password) {
                    this.originalVerify = 'empty';
                    return false;
                }
                return true;
            }
            var passReg = /^[a-zA-Z\d!#$%^&*_]{6,20}$/;
            if (!password) {
                this[verify] = 'empty';
                return false;
            } else if (passReg.test(password)) {
                if (verify === 'confirmVerify' && password !== this.newPassword) {
                    this[verify] = 'difference';
                    return false;
                }
                this[verify] = 'right';
                return true;
            }
            this[verify] = 'error';
            return false;
        },
        handleModifyPwd: function handleModifyPwd() {
            if (this.flag) {
                var that = this;
                that.flag = false;
                var originalPassword = this.originalPassword;
                var newPassword = this.newPassword;
                var confirmPassword = this.confirmPassword;
                var checkOriginal = this.checkPassword(originalPassword, 'originalVerify');
                var checkNew = this.checkPassword(newPassword, 'newVerify');
                var checkConfirm = this.checkPassword(confirmPassword, 'confirmVerify');
                if (checkOriginal && checkNew && checkConfirm) {
                    this.loading = true;
                    that.$http.put('/v1/user-center/password', {
                        oldPassword: originalPassword,
                        newPassword: newPassword
                    }).then(function (resp) {
                        return that.$checkResp(resp);
                    }).then(function () {
                        that.$message.info('密码修改成功');
                        that.$router.push({ name: 'basic@user' });
                    }).catch(function (err) {
                        that.warnVerify = 'error';
                        that.warnMsg = err.msg;
                    }).finally(function () {
                        that.flag = true;
                        that.loading = false;
                    });
                } else {
                    that.flag = true;
                }
            }
        }
    }
});

/***/ }),

/***/ "Z4Pj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserPassword_vue__ = __webpack_require__("VPQo");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7dabbe6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserPassword_vue__ = __webpack_require__("SVdM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("7ydy")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d7dabbe6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7dabbe6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserPassword_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7dabbe6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserPassword_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/54.aa16a4017db55caebd51.js